import axios from 'axios'
import {transParams} from "@/utils/paramsUtils";
import cache from "@/plugins/cache";
import msgModal from "@/plugins/modal"
import errMessage from "@/utils/errMessage";
import {ElMessageBox} from "element-plus";
import {getToken} from "@/utils/auth";
import bus from "@/plugins/bus"

//默认的请求头配置
axios.defaults.headers['Content-Type'] = 'application/json;charset=utf-8'

//创建 axios 示例
const service = axios.create({
    baseURL: process.env.VUE_APP_BASE_API, // 配置请求根路径
    timeout: 10000  // 超时
})

//设置 请求拦截器
service.interceptors.request.use(config => {

    //get请求映射params参数
    if (config.method === 'get' && config.params) {
        let url = config.url + '?' + transParams(config.params);
        url = url.slice(0, -1)
        config.params = {}
        config.url = url
    }

    //是否需要token
    const isToken = (config.headers || {})['isToken'] === false
    //需要token
    if (!isToken && getToken()) {
        config.headers['Authorization'] = 'Bearer ' + getToken()
    }

    //是否需要防止数据重复提交
    const isRepeatSubmit = (config.headers || {})['repeatSubmit'] === false
    //防止重复提交
    if (!isRepeatSubmit && (config.method === 'post' || config.method === 'put')) {
        const requestObj = {
            url: config.url,
            data: typeof config.data === 'object' ? JSON.stringify(config.data) : config.data,
            time: new Date().getTime()
        }

        //请求数据大小
        const requestSize = Object.keys(JSON.stringify(requestObj)).length
        const limitSize = 5 * 1024 * 1024
        if (requestSize > limitSize) {
            console.warn(`[${config.url}]: ` + '请求数据大小超出允许的5M限制，无法进行防重复提交验证。')
            return config
        }
        const sessionObj = cache.session.getJSON('sessionObj')
        if (sessionObj === undefined || sessionObj === null || sessionObj === '') {
            cache.session.setJSON('sessionObj', requestObj)
        } else {
            const s_url = sessionObj.url                  // 请求地址
            const s_data = sessionObj.data                // 请求数据
            const s_time = sessionObj.time                // 请求时间
            const interval = 3000                         // 间隔时间(ms)，小于此时间视为重复提交
            if (s_data === requestObj.data && requestObj.time - s_time < interval && s_url === requestObj.url) {
                const message = '数据正在处理，请勿重复提交'
                console.warn(`[${s_url}]: ` + message)
                return Promise.reject(new Error(message))
            } else {
                cache.session.setJSON('sessionObj', requestObj)
            }
        }
    }
    return config
}, error => {
    console.log(error)
    Promise.reject(error)
})

//设置 响应拦截器
service.interceptors.response.use(response => {
        //如果是二进制消息 直接返回
        if (response.request.responseType === 'blob' || response.request.responseType === 'arraybuffer') {
            return response.data
        }
        //状态码判断 没有设置 默认200
        const code = response.data.code || 200
        // 获取消息
        const message = response.data.msg || errMessage[code] || errMessage['default']

        if (code === 401) {
            ElMessageBox.confirm('登录状态已过期，你可以继续留在该页面，或者重新登录',
                '系统提示',
                {
                    confirmButtonText: '立即登录',
                    cancelButtonText: '继续浏览',
                    type: 'warning',
                }
            ).then(() => {
                bus.emit('loginModal:open')
            })
            return Promise.reject('无效的会话，或者会话已过期，请重新登录。')
        } else if (code === 500) {
            msgModal.notice(message, '', '系统提示')
            return Promise.reject(new Error(message))
        } else if (code === 601) {
            msgModal.notice(message, 'warning', '系统提示')
            return Promise.reject('error')
        } else if (code !== 200) {
            msgModal.alert(message, 'warning', '系统提示')
            return Promise.reject('error')
        } else {
            return response.data
        }
    }, error => {
        console.log('err' + error)
        let {message} = error
        if (message === "Network Error") {
            message = "当前网络异常，请检查网络环境！"
        } else if (message.includes("timeout")) {
            message = "系统接口请求超时，请稍后再试"
        } else if (message.includes("Request failed with status code")) {
            message = "系统接口" + message.substr(message.length - 3) + "异常"
        }
        msgModal.alert(message, 'warning', '系统提示')
        return Promise.reject(error)
    }
)


export default service